export default __webpack_public_path__ + "static/media/wph.e0d82b70.png";